import { memo } from 'motion-utils';
var supportsWaapi = /*@__PURE__*/memo(function () {
  return Object.hasOwnProperty.call(Element.prototype, "animate");
});
export { supportsWaapi };